module.exports = __webpack_public_path__ + "Roboto-500.1afbee5a09a022fe0287.woff2";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.woff2
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-500/Roboto-500.woff2
// module chunks = main styles